import React from 'react'

const StarRating = ({ rating, maxRating = 5, size = 'w-5 h-5' }) => (
  <div className="text-right">
    <div className="flex items-center gap-1">
      {[...Array(maxRating)].map((_, i) => (
        <svg
          key={i}
          className={`${size} ${i < rating ? 'text-yellow-400' : 'text-black'}`}
          fill={i < rating ? "currentColor" : "none"}
          stroke={i < rating ? "none" : "currentColor"}
          strokeWidth={i < rating ? "0" : "2"}
          viewBox="0 0 24 24"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
    <span className="text-gray-300 text-sm">Rating: {rating}/{maxRating}</span>
  </div>
)

export default StarRating